export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 16 16">
            <path fill="currentColor" d="M1.116 9.116h5.768v5.768c0 .326.105.593.314.802.21.21.477.314.802.314.325 0 .593-.105.802-.314.209-.209.314-.476.314-.802V9.116h5.768c.326 0 .593-.105.802-.314.21-.21.314-.477.314-.802 0-.325-.105-.593-.314-.802a1.086 1.086 0 0 0-.802-.314H9.116V1.116c0-.326-.105-.593-.314-.802A1.086 1.086 0 0 0 8 0c-.325 0-.593.105-.802.314-.209.209-.314.476-.314.802v5.768H1.116c-.326 0-.593.105-.802.314C.104 7.408 0 7.675 0 8c0 .325.105.593.314.802.209.209.476.314.802.314z" />
        </svg>
    );
}
